/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import RepositoryLink from 'src/components/repository-link';

export const BreadcrumbsItemRepositoryLink = styled(RepositoryLink)({
  color: token('color.text.subtle'),
  padding: `${token('space.025')} 0`,
  '&:hover': {
    color: token('color.text.subtle'),
  },
  '&:focus': {
    color: token('color.text.subtle'),
  },
});
